<template>
  <div v-if="renderData && renderData.length && renderData.length > 1" class="FullWidthBannercard d-flex flex-column"
    :class="{
      'filter-landing-widget-wrapper': isFilterLanding,
      'shop-the-look': callerComp==='shopTheLook',
      'supima-landing': callerComp === 'supimaLandingPage',
      'activewear-landing': callerComp === 'activeWearLandingPage' || callerComp === 'winterWearLandingPage'
    }"
    :style="[bannerStyle]"
  >
    <div class="FullWidthBannercard__title-cont" v-if="renderName || getDescription">
      <div class='title_container'>
        <div v-if="isFilterLanding">
          <div v-if="renderName" class="category-title-container">
            <div class='mobile-lines-container'>
              <div v-for="(e, i) in deviceWidth" :key="i" class='rotate-line'>|</div>
            </div>
            <h3 class="filter-landing-title">{{renderName}}</h3>
          </div>
        </div>
        <h3 v-else-if="renderName" class='title' :class="!isDesktop ? 'pl-4' : ''">{{renderName}}</h3>
      </div>
      <p v-if="getDescription" class="descrition">{{getDescription}}</p>
    </div>
    <div class="headtop prelative top-banner">
      <carousel ref="my-carousel" :navigationEnabled="isDesktop"
        :paginationEnabled="isPaginationProp ? showPagination : callerComp!=='shopTheLook' && !isDesktop " navigationNextLabel=" " navigationPrevLabel=" "
        :autoplay="false" :loop="isFilterLanding ? true : ''" :autoplayTimeout="isFilterLanding ? 4000 : 2500" :speed="500" :class="isDesktop ? 'bannerview' : 'mobileBannerView'" :perPage="1"
        :paginationPadding="1" :paginationSize="6" :paginationPosition="'bottom'"
        :paginationActiveColor="paginationActiveColor && paginationActiveColor" :paginationColor="paginationColor ? paginationColor : '#979a9f'"
      >
        <slide v-for="(bimg, index) in renderData.slice(0, renderData.length-1)" :key="index">
            <div v-if="bimg.is_video && (bimg.video_url || bimg.web_video_url)" class='w-full'>
              <VideoPlayer
                :src="isDesktop ? bimg.web_video_url : bimg.video_url"
                :poster="isDesktop ? bimg.image_web : bimg.image"
                :playVideo="true"
              />
            </div>
            <div v-else>
              <a v-if="bimg.navigation_link || isHTTPUrl(bimg.url)"
                :href="bimg.navigation_link || bimg.url"
                class="d-inline-block w-100"
                v-bannerImageLoad="callerComp === 'homePage' ? getBannerImpressionData(bimg, index) : null"
              >
              <router-link :to="bimg.left_url || ''" @click.native="onClickEventsHandler({...bimg, side: 'left'}, index)">
                <img @click="onClickEventsHandler(bimg, index)"
                  :class="{customFade: callerComp === 'homePage'}"
                  :data-url="callerComp === 'homePage' ? getImageSrc(bimg) : ''"
                  :data-src="callerComp === 'homePage' ? '' : getImageSrc(bimg)"
                  :alt="bimg.navigation_link || bimg.alt || 'Banner'"
                  class="img-auto"
                  width="1500" height="385"
                >
              </router-link>
              </a>
              <router-link v-else
                :to="{path: getImageUrl(bimg) || '', hash: getImageHashUrl(bimg) || ''}"
                class="d-inline-block w-100 my-1"
                v-bannerImageLoad="callerComp === 'homePage' ? getBannerImpressionData(bimg, index) : null"
              >
                <img @click="handleBannerClick(bimg, index)"
                  :class="{customFade: callerComp === 'homePage'}"
                  :data-url="callerComp === 'homePage' ? getImageSrc(bimg) : ''"
                  :data-src="callerComp === 'homePage' ? '' : getImageSrc(bimg)"
                  :alt="bimg.url || bimg.alt || 'Banner'"
                  class="img-auto"
                  width="1500" height="385"
                >
              </router-link>
              <div v-if="bimg.is_banner_split" class='pabsolute w-full banner-btns-wrapper d-flex justify-content-center'>
                <router-link :to="bimg.left_url || ''" @click.native="onClickEventsHandler({...bimg, side: 'left'}, index)">
                  <button class='btn btn-danger text-uppercase left-btn'>{{isDesktop ? 'men' : 'shop men'}}</button>
                </router-link>
                <router-link :to="bimg.right_url || ''"  @click.native="onClickEventsHandler({...bimg, side: 'right'}, index)">
                  <button class='btn btn-danger text-uppercase right-btn'>{{isDesktop ? 'women' : 'shop women'}}</button>
                </router-link>
              </div>
            </div>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
var $ = require('jquery')
window.jQuery = $
import {Carousel, Slide} from 'vue-carousel'
import VideoPlayer from './VideoPlayer.vue'
import {mapGetters} from 'vuex'
import Vue from 'vue'
import {getProductUrl} from '../../assets/js/common'
import FullWidthCarousalPlaceholder from './ShimmerEffectPlaceHolder.vue'
export default {
  data () {
    return {
      isDesktop: this.$parent.$parent.isDesktop
    }
  },
  props: ['renderName', 'renderData', 'isFilterLanding', 'bannerStyle', 'showPagination', 'isPaginationProp', 'paginationActiveColor', 'paginationColor', 'deviceWidth', 'isPauseForPaws', 'callerComp', 'handleItemClick', 'gender', 'widgetType'],
  components: {
    Carousel,
    Slide,
    VideoPlayer,
    FullWidthCarousalPlaceholder
  },
  computed: {
    ...mapGetters(['isExclusive', 'authStatus', 'webcategory']),
    getDescription: function () {
      if (this.renderData && this.renderData.length > 1) {
        return this.renderData[this.renderData.length - 1][3]
      }
    },
    getRenderDataModelName () {
      if (this.renderData && this.renderData.length > 1) {
        return this.renderData[this.renderData.length - 1] && this.renderData[this.renderData.length - 1][0]
      }
    }
  },
  methods: {
    getRedirectionLink: function (prm) {
      if (prm && (prm.is_pdp || prm.product_slug)) {
        return `/product/${prm.product_slug}?gte=${prm.is_women || prm.gender ? 2 : 1}`
      } else if (prm && prm.url && !prm.is_pdp) {
        return prm.url
      } else {
        return ''
      }
    },
    handleBannerClick (prm, index) {
      if (this.handleItemClick) {
        this.handleItemClick({...prm, widgetType: this.widgetType}, index)
      }
      this.onClickEventsHandler(prm, index)
    },
    onClickEventsHandler (obj, index) {
      const cachedgender = Vue.ls.get('tss_landingCategory')
      let payload = {
        callerComp: this.callerComp,
        itemUrl: obj.is_banner_split ? obj.side === 'left' ? obj.left_url : obj.right_url : (obj.navigation_link || obj.url),
        index,
        bannerName: this.renderName
      }
      if (this.gender) {
        payload = {
          ...payload,
          gender: this.gender === 2 ? 'women' : 'men'
        }
      }
      if (this.callerComp === 'activeWearLandingPage' || this.callerComp === 'filterLandingPage' || this.callerComp === 'winterWearLandingPage') {
        this.$store.commit('GTAG_EVENT', {eventName: this.callerComp + '_fullWidthCaruselBanner_click',
          payload: {
            route: Vue.ls.get('routeObj'),
            url: payload.itemUrl,
            index: index,
            bannerName: this.renderName,
            gender: payload.gender
          }}
        )
      }
      const bannerImpressionData = this.getBannerImpressionData(obj, index + 1)
      this.getRenderDataModelName && this.getRenderDataModelName.length && this.getRenderDataModelName.toLowerCase() === 'straight out of celebrity closets' ? this.$store.commit('GTAG_EVENT', {eventName: 'celebrity_curation_fullWidthCaruselBanner_click', payload: {route: Vue.ls.get('routeObj'), url: payload.itemUrl, index: payload.index, bannerName: payload.bannerName}}) : ''
      let evenrPayload = {
        creative_name: bannerImpressionData.creative_name ? bannerImpressionData.creative_name : 'NA',
        creative_slot: bannerImpressionData.creative_slot || bannerImpressionData.creative_slot === 0 ? bannerImpressionData.creative_slot : 'NA',
        promotion_id: bannerImpressionData.promotion_id ? bannerImpressionData.promotion_id : 'NA',
        creative_image: bannerImpressionData && bannerImpressionData.creative_img ? bannerImpressionData.creative_img : 'NA',
        promotion_name: bannerImpressionData.promotion_name ? bannerImpressionData.promotion_name : 'NA',
        promotion_tab: this.webcategory || 'NA'
      }
      if (this.callerComp === 'homePage') {
        this.$store.dispatch('ECOMMERCE_EVENT', { eventName: 'select_promotion', payload: evenrPayload })
        this.$store.commit('GTM_EVENT', { eventName: 'select_promotion', payload: evenrPayload })
      }
      this.$store.commit('SET_NAVIGATION_WIDGET', this.renderName || this.widgetType)
      this.$store.commit('MOENGAGE_EVENT', {eventName: 'HOMEPAGE-SECTION',
        payload: {
          Section_Name: this.renderName || '',
          Section_Index: index,
          Product_Category: '',
          Product_Name: '',
          Product_ID: '',
          Product_Price: '',
          Product_Artist: '',
          ProductImage_URL: this.getImageSrc(obj),
          Product_URL: this.getProductUrl(false, payload.itemUrl, ''),
          GENDER: cachedgender
        }}
      )
      this.$store.commit('MOENGAGE_EVENT', {eventName: 'BANNER',
        payload: {
          Index_position: index,
          Description: this.renderName || '',
          BannerURL: this.getProductUrl(false, payload.itemUrl, ''),
          'Sub-Category': '',
          Category: '',
          Theme: ''
        }}
      )
    },
    getBannerImpressionData (obj, index) {
      return {
        promotion_id: obj.id || '',
        promotion_name: obj.promotion_name || this.renderName || '',
        creative_name: obj.product_type || obj.title || this.renderName || '',
        creative_slot: index,
        creative_img: this.isDesktop ? obj.image_web : obj.image || 'NA',
        currency: 'INR'
      }
    },
    isHTTPUrl (url) {
      return url && url.includes('http')
    },
    getImageSrc (item) {
      if (this.gender) {
        return this.gender === 2
        ? this.isDesktop ? item.web_image_women : item.mobile_image_women
        : this.isDesktop ? item.web_image_men : item.mobile_image_men
      }
      return this.isDesktop ? (item.image_web || item.web_image) : item.image
    },
    getImageUrl (item) {
      if (item && (item.is_pdp || item.product_slug)) {
        return `/product/${item.product_slug}?gte=${item.is_women || item.gender ? 2 : 1}`
      } else if (item && !item.is_pdp && this.gender) {
        return this.gender === 2 ? item.women_url && item.women_url.startsWith('#') ? '' : item.women_url
        : item.men_url && item.men_url.startsWith('#') ? '' : item.men_url
      } else if (item && !item.is_pdp && item.url) {
        return item.url
      }
    },
    getImageHashUrl (item) {
      if (this.gender) {
        return this.gender === 2 ? item.women_url && item.women_url.startsWith('#') ? item.women_url : ''
        : item.men_url && item.men_url.startsWith('#') ? item.men_url : ''
      }
      return ''
    },
    getProductUrl
  }
}
</script>

<style scoped>
  .FullWidthBannercard {
    margin: 1rem 0;
    min-height: 526px;
  }
  .image-wrapper {
    text-align: center;
    position: relative;
  }
  .pause-for-paws-icon{
    height: 5rem;
    width: 5rem;
    margin-bottom: -0.5rem;
  }
  .filter-landing-widget-wrapper {
    box-shadow: unset !important;
    margin-top: 0;
    margin-bottom: 2.5rem;
    padding: unset;
  }
  .shop-the-look {
    margin-top: 0;
  }

  .supima-landing, .activewear-landing {
    margin: 0;
    padding: 0;
  }
  .banner-btns-wrapper {
    bottom: 60px;
    gap: 8px;
  }
  .banner-btns-wrapper button {
    min-width: 140px;
    line-height: 26px;
    font-size: 17px;
    border-radius: 0px;
    background-color: #e11b23;
    border-color: #e11b23;
    font-weight: normal;
  }
  .banner-btns-wrapper a:hover{
    color: #fff;
  }
  .banner-btns-wrapper a:focus{
    color: #fff;
  }
  .supima-landing .banner-btns-wrapper button {
    font-family: 'Futura' !important;
  }
  .activewear-landing .banner-btns-wrapper {
    height: 100%;
    bottom: 0;
  }
  .activewear-landing .banner-btns-wrapper a {
    flex: 1;
  }
  .activewear-landing .banner-btns-wrapper button{
    display: none;
  }
  .FullWidthBannercard .title {
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    text-transform: uppercase;
    margin: 0;
  }
  .FullWidthBannercard .title_container{
    display:flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }
  .FullWidthBannercard .filter-landing-title {
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    text-transform: capitalize;
    margin: 0;
    font-size: 2.3rem;
   position: absolute;
    background-color: white;
    padding-left: 3.2rem;
    padding-right: 3.2rem;
  }
  .shop-the-look .filter-landing-title {
    position: unset;
  }
  .image-wrapper {
    text-align: center;
  }
  .FullWidthBannercard__title-cont {
    /* margin-bottom: 2rem; */
    margin-bottom: 1.5rem;
    margin-top: 1.5rem !important;
  }
  .shop-the-look .FullWidthBannercard__title-cont {
    margin: 1rem 0;
  }
  .FullWidthBannercard__title-cont .descrition {
    font-size: 1.6rem;
    line-height: 1.26;
    letter-spacing: normal;
    text-align: center;
    color: #525964;
    margin: 0;
  }
  .category-title-container{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    position: relative;
  }
  .category-title-container .rotate-line{
  transform: rotate(40deg);
  }
  .category-title-container .mobile-lines-container{
    display: flex;
    gap: 5px;
    font-size: 1.3rem;
    color: lightgray;
    font-weight: unset;
  }
  @media screen and (max-width: 768px) {
    .FullWidthBannercard .title {
      font-size: 1.13rem;
    }
    .FullWidthBannercard .title_container{
      justify-content: left;
    }
    .pause-for-paws-icon{
      height: 3rem;
      width: 3rem;
      margin-bottom: unset;
    }
    .FullWidthBannercard .filter-landing-title {
      font-size: .8rem;
      border-bottom: unset;
      padding-left: 1.2rem;
      padding-right: 1.2rem;
    }
    .FullWidthBannercard {
      margin: 0;
      padding: 1rem 0rem 0.1rem 0rem;
      background-color: #ffffff;
      min-height: 349px;
    }
    .shop-the-look {
      padding: 0;
      margin-top: 0;
      box-shadow: none;
    }
    .filter-landing-widget-wrapper {
      box-shadow: unset !important;
      margin-top: 0;
      margin-bottom: 1.3rem;
      padding: unset;
    }
    .FullWidthBannercard__title-cont {
      margin-bottom: 1rem;
      margin-top: 0rem !important;
    }
    .img-card {
      border-radius: .3rem;
    }
    .FullWidthBannercard__title-cont .descrition {
      font-size: 1rem;
    }
    .category-title-container .mobile-lines-container{
      gap: 2px;
      font-size: 0.7rem;
      color: unset;
    }
    .shop-the-look .FullWidthBannercard__title-cont {
      margin-top: 0
    }
    .shop-the-look .title {
      font-size: 1.1rem;
    }
    .supima-landing, .activewear-landing {
      margin: 0;
      padding: 0;
      box-shadow: unset;
    }
    .banner-btns-wrapper {
      bottom: 20px;
      padding: 0 30px;
    }
    .banner-btns-wrapper a {
      flex: 1;
    }
    .banner-btns-wrapper button {
      min-width: 100px;
      line-height: 23px;
      font-size: 13px;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// FullWidthCarouselBanner.vue?3dc60592